




















import { Component, Prop } from 'vue-property-decorator';
import SaascadaVueProductForm from '@/components/Shared/SaascadaVueProductForm';
import FieldLabel from '@/components/Shared/FieldLabel.vue';
import { ProductDetailsModule } from '@/store/Products/ProductDetailsModule';

@Component({ name: 'GeneralFeeSettingsDialogForm', components: { FieldLabel } })
export default class extends SaascadaVueProductForm {

    @Prop({ required: true })
    isCreate: boolean

    get productVM() {
        return ProductDetailsModule.productVM;
    }

}
